import { createApiHook } from '../hooks';
import { accountResourcesApiFactory } from './accountResourcesApiFactory';

export const useAccountResourcesApi = createApiHook(accountResourcesApiFactory);
